import { PayoutMethodEnum } from 'enum/common';

export const signIn = `${process.env.REACT_APP_SERVER_URL_V1}/signin`;
export const myBusinesses = `${process.env.REACT_APP_SERVER_URL_V1}/my-businesses`;
export const countries = `${process.env.REACT_APP_SERVER_URL_V1}/get-countries`;
export const states = (countryCode: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/get-states?country_code=${countryCode}`;
export const cities = (countryCode: string, stateCode: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/get-cities?state_code=${stateCode}&country_code=${countryCode}`;
export const topUpHistory = (
  businessUuid: string,
  limit?: number | string,
  offset?: number | string,
) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/transactions?limit=${limit}&offset=${offset}`;
export const rewardsSummary = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/rewards-summary`;
export const businessPlans = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/business-paid-modules`;
export const getUser = (uuid: string) => `${process.env.REACT_APP_SERVER_URL_V1}/user/${uuid}`;
export const businessOverallStatsApi = (uuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/entity/${uuid}/business-overall-stats`;
export const userFeedbackApi = (uuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V2}/business/${uuid}/user-feedback?ordering=-createdAt`;
export const getBusiness = (uuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${uuid}`;
export const updateBusiness = (uuid: string) =>
  `/business/${uuid}?persona=business`;
export const getTransactionStatus = (businessId: string, planId: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessId}/business-paid-modules/${planId}/get-stripe-session-status`;
export const getPayoutMethods = (type: PayoutMethodEnum, uuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/accounts/${type}?business_uuid=${uuid}`;
export const addPayoutMethod = (type: PayoutMethodEnum, businessUuid: string) =>
  `/accounts/${type}?business_uuid=${businessUuid}`;
export const deletePayoutMethod = (businessUuid: string) =>
  `/accounts/default?business_uuid=${businessUuid}`;
export const updatePayoutMethod = (type: PayoutMethodEnum, uuid: string, businessUuid: string) =>
  `/accounts/${type}/${uuid}?business_uuid=${businessUuid}`;
export const getDefaultAccount = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/default-account`;
export const downloadQrApi = (businessUuid: string) => `/business/${businessUuid}/download-qr-code`;

// Subscription APIs
export const createSubscription = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/subscriptions`;
export const getSubscriptions = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/subscriptions`;
export const updateSubscription = (businessUuid: string, subscriptionUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/subscription/${subscriptionUuid}`;
export const deleteSubscription = (businessUuid: string, subscriptionUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/subscription/${subscriptionUuid}`;
export const subscriptionAdvisor = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/subscriptions/advisor`;
export const subscriptionAdvisorHistory = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/subscriptions/advisor/history`;

export const subscriptionAdvisorUsageCheck = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/subscriptions/advisor/usage-check`;
export const subscriptionExamples = () =>
  `${process.env.REACT_APP_SERVER_URL_V1}/subscriptions/examples`;

// Business Paid Modules APIs (for subscription module activation)
export const getBusinessPaidModules = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/business-paid-modules`;
export const updateBusinessPaidModule = (businessUuid: string, paidModuleId: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/business-paid-modules/${paidModuleId}`;
export const onboardingRequest = `${process.env.REACT_APP_SERVER_URL_V2}/onboarding-request`;
export const businessCategories = `${process.env.REACT_APP_SERVER_URL_V1}/business-categories`;
export const uploadPreSignedUrl = `${process.env.REACT_APP_SERVER_URL_V1}/upload/pre-signed-url`;
export const communitiesDropdown = `${process.env.REACT_APP_SERVER_URL_V1}/communities-dropdown`;
export const community = `${process.env.REACT_APP_SERVER_URL_V1}/community`;
export const signUp = (verifyWith: string) =>
  `${process.env.REACT_APP_SERVER_URL_V2}/signup?verifyWith=${verifyWith}`;
export const verifyUser = (sendTo: string) =>
  `${process.env.REACT_APP_SERVER_URL_V2}/verify/new-user?sendTo=${sendTo}`;
export const resendCode = (sendTo: string) =>
  `${process.env.REACT_APP_SERVER_URL_V2}/resend/new-user?sendTo=${sendTo}`;
export const countryExtensions = `${process.env.REACT_APP_SERVER_URL_V1}/country-extensions`;
export const forgotPassword = `${process.env.REACT_APP_SERVER_URL_V2}/forgot-password`;
export const passwordUpdate = `${process.env.REACT_APP_SERVER_URL_V1}/password-update`;
export const verifyForgotPassword = (sendTo: string) =>
  `${process.env.REACT_APP_SERVER_URL_V2}/verify/forgot-password?sendTo=${sendTo}`;
export const resendForgotPasswordCode = (sendTo: string) =>
  `${process.env.REACT_APP_SERVER_URL_V2}/resend/forgot-password?sendTo=${sendTo}`;

// Employee/Merchant Pin APIs
export const getEmployees = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/employees`;
export const createEmployee = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/employees`;
export const updateEmployee = (businessUuid: string, employeeUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/employees/${employeeUuid}`;
export const deleteEmployee = (businessUuid: string, employeeUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/employees/${employeeUuid}`;

// Business Users APIs
export const getBusinessUsers = (businessUuid: string, limit = 10, offset = 0) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/users?limit=${limit}&offset=${offset}`;
export const getInvitedUsers = (businessUuid: string, limit = 10, offset = 0) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/invited-users?limit=${limit}&offset=${offset}`;
export const inviteUser = (businessUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/invite-user`;
export const cancelInvitation = (businessUuid: string, invitationUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/invited-users/${invitationUuid}`;
export const resendInvitation = (businessUuid: string, invitationUuid: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/${businessUuid}/invited-users/${invitationUuid}/resend`;

// Invite APIs
export const verifyInviteApi = (token: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/verify-invite/${token}`;
export const acceptInviteApi = (token: string) =>
  `${process.env.REACT_APP_SERVER_URL_V1}/business/accept-invite/${token}`;
